export default __webpack_public_path__ + "static/logo-734f227d7bdde2cd82fb634350abf3bd.png";